import { appConfig } from "@/shared/config";
import { requestSupportToken } from "@/shared/api/support";
/**
 * Открыть бот поддержки (Telegram/MAX) с идентифицирующим deep-link.
 *
 * Вкладку открываем СИНХРОННО (сохраняем user gesture, чтобы попап не
 * блокировался после await), затем ведём её на `?start=vsite_<token>`, как
 * только придёт токен. Токен минтим для ЛЮБОГО юзера с сессией — в т.ч. гостя:
 * у него есть свой user_id, и Omnidesk по нему покажет карточку. Нет сессии /
 * сбой запроса токена → деградируем на плейн-ссылку, не блокируя юзера.
 */
export const openSupportBot = async (bot) => {
    const baseUrl = appConfig.supportBots[bot];
    const popup = window.open("about:blank", "_blank");
    if (popup)
        popup.opener = null;
    let url = baseUrl;
    try {
        const { token } = await requestSupportToken();
        if (token)
            url = `${baseUrl}?start=vsite_${token}`;
    }
    catch {
        // Токен не пришёл — деградируем на плейн-ссылку.
    }
    if (popup) {
        popup.location.href = url;
    }
    else {
        // Попап заблокировали — best-effort прямое открытие.
        window.open(url, "_blank", "noopener,noreferrer");
    }
};
